/**
 * <ReferralBenefitBanner> — referee free-trial reminder (molecule, L0.1).
 */
import { StyleSheet } from "react-native-unistyles"

import { Icon } from "../../atoms/icons/Icon"
import { Row } from "../../atoms/containers/Row"
import { Text } from "../../atoms/typography/Text"
import { Card } from "../Card"

export type ReferralBenefitBannerProps = {
    testID?: string
}

export function ReferralBenefitBanner(props: ReferralBenefitBannerProps) {
    const { testID } = props

    return (
        <Card p="3" background="primary-soft" testID={testID}>
            <Row align="center" gap="3">
                <Icon name="gift" size={16} color="primary" solid />
                <Text size="text-sm" color="primary" style={styles.flex}>
                    Votre filleul profite d&apos;une{" "}
                    <Text size="text-sm" weight="bold" color="primary">
                        séance découverte gratuite
                    </Text>
                </Text>
            </Row>
        </Card>
    )
}

const styles = StyleSheet.create(() => ({
    flex: {
        flex: 1,
        flexShrink: 1,
    },
}))
